/* eslint-disable no-restricted-syntax */
import { onFieldChangeStateComparison } from '../onFieldChangeStateComparison';
import { simpleFieldTracking } from '../formTracking';
import { otherEventTracking, findOtherEventIndex } from '../otherEventTracking';
import {
    NAVIGATE_TO_LANDING_PAGE,
    NAVIGATE_TO_INVESTMENT_SETUP_INITIAL,
    NAVIGATE_TO_INVESTMENT_SETUP_CONTRIBUTION,
    NAVIGATE_TO_SELECT_A_FUND,
    NAVIGATE_TO_ADVANCED_FUND_PICKER,
    NAVIGATE_TO_FUND_SPLIT,
    NAVIGATE_TO_PERSONAL_DETAILS,
    NAVIGATE_TO_AUXILIARY_DETAILS,
    // NAVIGATE_TO_BENEFICIARIES,
    // NAVIGATE_TO_BENEFICIARIES_SPLIT,
    NAVIGATE_TO_PAYMENT_DETAILS,
    NAVIGATE_TO_REVIEW,
    NAVIGATE_TO_THANK_YOU,
} from '../../../actions/taxFreeSavingsAccount/routing';
import { PAGES } from '../../../actions/taxFreeSavingsAccount/types';

import { getActivePageIndex } from '../../../selectors/taxFreeSavingsAccount/routing';
import { fireGtmEvent } from '../gtmEvents';

let landedOnAdvancedFundPicker = false;
let landedOnFundSplit =false;

export const routingOtherTracking = (store, next, action) => {
    const state = store.getState();
    const result = next(action);
    let otherEventIndex;    
    
    const field = (() => {
        switch (action.type) {
            case NAVIGATE_TO_LANDING_PAGE:
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Landing Page';

            case NAVIGATE_TO_INVESTMENT_SETUP_INITIAL:
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Investment Setup Initial Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            case NAVIGATE_TO_PERSONAL_DETAILS:
                fireGtmEvent('application_form_complete', {
                    form_name: 'TFSA',
                    application_step: '1',
                    application_name: 'Investment Setup Initial',
                });
                
                fireGtmEvent('application_form_impression', {
                    form_name: 'TFSA',
                    application_step: '2',
                    application_name: 'Personal Details',
                });
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Personal Details Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            case NAVIGATE_TO_INVESTMENT_SETUP_CONTRIBUTION:
                fireGtmEvent('application_form_complete', {
                    form_name: 'TFSA',
                    application_step: '2',
                    application_name: 'Personal Details',
                });
                
                fireGtmEvent('application_form_impression', {
                    form_name: 'TFSA',
                    application_step: '3',
                    application_name: 'Investment Setup Contribution',
                });
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return (
                    'Navigate To Investment Setup Contribution Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE
                );

            case NAVIGATE_TO_SELECT_A_FUND:
                fireGtmEvent('application_form_complete', {
                    form_name: 'TFSA',
                    application_step: '3',
                    application_name: 'Investment Setup Contribution',
                });
                
                fireGtmEvent('application_form_impression', {
                    form_name: 'TFSA',
                    application_step: '4',
                    application_name: 'Select a Fund',
                });
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Select A Fund Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            case NAVIGATE_TO_ADVANCED_FUND_PICKER:
                landedOnAdvancedFundPicker = true;

                fireGtmEvent('application_form_complete', {
                    form_name: 'TFSA',
                    application_step: '4',
                    application_name: 'Select a Fund',
                });
                
                fireGtmEvent('application_form_impression', {
                    form_name: 'TFSA',
                    application_step: '5',
                    application_name: 'Advanced Fund Picker',
                });
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Advanced Fund Picker Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            case NAVIGATE_TO_FUND_SPLIT:
                landedOnFundSplit = true;
                landedOnAdvancedFundPicker = false;

                fireGtmEvent('application_form_complete', {
                    form_name: 'TFSA',
                    application_step: '5',
                    application_name: 'Advanced Fund Picker',
                });
                
                fireGtmEvent('application_form_impression', {
                    form_name: 'TFSA',
                    application_step: '6',
                    application_name: 'Fund Split',
                });
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Fund Split Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            case NAVIGATE_TO_AUXILIARY_DETAILS:
                if(landedOnFundSplit) {
                    fireGtmEvent('application_form_complete', {
                        form_name: 'TFSA',
                        application_step: '6',
                        application_name: 'Fund Split',
                    });
                } else if(landedOnAdvancedFundPicker) {
                    fireGtmEvent('application_form_complete', {
                        form_name: 'TFSA',
                        application_step: '5',
                        application_name: 'Advanced Fund Picker',
                    });
                } else {
                    fireGtmEvent('application_form_complete', {
                        form_name: 'TFSA',
                        application_step: '4',
                        application_name: 'Select a Fund',
                    });
                }

                fireGtmEvent('application_form_impression', {
                    form_name: 'TFSA',
                    application_step: '7',
                    application_name: 'Auxiliary Details',
                });
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Auxliary Details Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            // case NAVIGATE_TO_BENEFICIARIES:
            //     otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
            //     return 'Navigate To Beneficiaries Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;
            //
            // case NAVIGATE_TO_BENEFICIARIES_SPLIT:
            //     otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
            //     return 'Navigate To Beneficiaries Split Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            case NAVIGATE_TO_PAYMENT_DETAILS:
                fireGtmEvent('application_form_complete', {
                    form_name: 'TFSA',
                    application_step: '7',
                    application_name: 'Auxiliary Details',
                });
                
                fireGtmEvent('application_form_impression', {
                    form_name: 'TFSA',
                    application_step: '8',
                    application_name: 'Payment Details',
                });
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Payment Details Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            case NAVIGATE_TO_REVIEW:
                fireGtmEvent('application_form_complete', {
                    form_name: 'TFSA',
                    application_step: '8',
                    application_name: 'Payment Details',
                });
                
                fireGtmEvent('application_form_impression', {
                    form_name: 'TFSA',
                    application_step: '9',
                    application_name: 'Review',
                });
                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Review Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            case NAVIGATE_TO_THANK_YOU:
                fireGtmEvent('application_form_complete', {
                    form_name: 'TFSA',
                    application_step: '9',
                    application_name: 'Review',
                });

                fireGtmEvent('form_complete', {
                    form_name: 'TFSA',
                });

                otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
                return 'Navigate To Thank You Page' + ' from ' + PAGES[getActivePageIndex(state)].TITLE;

            default:
                fireGtmEvent('user_abandoned', {
                    form_name: 'TFSA',
                    application_name: 'Investment Setup Initial',
                });
                return null;
        }
    })();

    if (field) {
        otherEventTracking(action.type, otherEventIndex, field);
    }

    return result;
};
